var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.916 2.75C7.08352 2.75 3.16602 6.66751 3.16602 11.5C3.16602 16.3325 7.08352 20.25 11.916 20.25C16.7485 20.25 20.666 16.3325 20.666 11.5C20.666 6.66751 16.7485 2.75 11.916 2.75ZM1.66602 11.5C1.66602 5.83908 6.2551 1.25 11.916 1.25C17.5769 1.25 22.166 5.83908 22.166 11.5C22.166 14.0605 21.2271 16.4017 19.6749 18.1982L22.9463 21.4697C23.2392 21.7626 23.2392 22.2374 22.9463 22.5303C22.6535 22.8232 22.1786 22.8232 21.8857 22.5303L18.6142 19.2589C16.8178 20.8111 14.4765 21.75 11.916 21.75C6.2551 21.75 1.66602 17.1609 1.66602 11.5Z",
    fill: "#4F4F4F",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMsg);
export default __webpack_public_path__ + "static/media/search_msg.9206b12a0bbb52ab667970d9c662d8db.svg";
export { ForwardRef as ReactComponent };